import React from 'react';

const Checkbox = ({name, value, ...rest}) => {
    return (
        <div className={`check-box ${rest.newClass}`}>
            <input
                type="checkbox"
                id="agree"
                name={name}
                checked={value}
                {...rest}
            />
            <label className={`checkmark ${rest.newClass}`}  htmlFor="agree" ></label>
            <span className={`${rest.newClass}`} >Subscribe To Timely Golf’s Newsletter</span>
        </div>
    );
};

export default Checkbox;
